'use strict';

import template from './template.html';
import './style.css';

const MAX_URL_LENGTH = 8192;
const BASE_MAP_URL_LENGTH = 202;
const LONGEST_POINT_LENGTH = 20;
const MAX_OTHER_PTS = (
  Math.floor(
    (MAX_URL_LENGTH - BASE_MAP_URL_LENGTH)
    / LONGEST_POINT_LENGTH
  ) - 1
);


export default function () {
  return {
    scope: {
      incidents: '<',
      curIncidentId: '<',
      width: '<',
      height: '<',
      apiKey: '<',
    },
    template: template,
    link: function (scope, _element, _attrs) {
      const cache = {};

      function _buildMapUrl() {
        if (scope.incidents.length === 0) {
          return null;
        }
        const markers = [];
        const otherPts = [];
        for (const i of scope.incidents) {
          if (!i.point) {
            continue;
          }
          const isCurrentIncident = (
            i.incident_id && i.incident_id === scope.curIncidentId
          );
          const loc = `${i.point[1].toFixed(5)},${i.point[0].toFixed(5)}`;
          if (isCurrentIncident) {
            markers.push(`markers=color:red%7C${loc}`)
          } else {
            // TODO: Should we have some smarter way of down-sampling in the future?
            if (otherPts.length > MAX_OTHER_PTS) {
              break;
            }
            otherPts.push(loc)
          }
        }
        markers.push('markers=color:black%7Csize:small%7C' + otherPts.join('|'));
        const markersParams = markers.join('&')
        return (
          `https://maps.googleapis.com/maps/api/staticmap` +
          `?size=${scope.width}x${scope.height}` +
          `&scale=2` +
          `&maptype=roadmap` +
          `&style=feature:poi|visibility:off` +
          `&${markersParams}` +
          `&key=${scope.apiKey}`
        );
      }

      scope.buildMapUrl = () => {
        const cacheKey = `cache:${scope.curIncidentId}:${scope.incidents.length}`;
        if (!cache[cacheKey]) {
          cache[cacheKey] = _buildMapUrl();
        }
        return cache[cacheKey];
      };
    },
  };
};
